import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import EditConfirm from '../../components/alert/EditAlert';
import { getVehicleType } from '../../graphql/queries';
import { updateVehicleType } from '../../graphql/mutations';
import { API, graphqlOperation } from "aws-amplify";
import gql from "graphql-tag";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Container,
    Row,
    Col
} from "reactstrap";
var schema = require('../../graphql/schema.json');

class UpdateVehicle extends Component {
    state = {
        success: false,
        open: false,
    }
    componentDidMount() {
        let category = schema.data.__schema.types.filter(item => { return item.name === 'VEHICLECATEGORY' })
        this.setState({ vehicleCategories: category[0].enumValues.map(item=> {return item.name}) })
        let { client } = this.props;
        let id = this.props.match.params.id;
        client.query({
            query: gql(getVehicleType),
            fetchPolicy: `network-only`,
            variables: { id, }
        }).then(res => {
            let { vehicleCategory, vehicleType } = res.data.getVehicleType
            this.setState({
                vehicleCategory, vehicleType, success: true
            });
        }).catch(err => {
        })
    }
    changeHandler = (e) => {
        let { id, value } = e.target;
        this.setState({ [id]: value });
    }
    submitHandler = () => {
        // e.preventDefault()
        let { vehicleCategory, vehicleType } = this.state;
        let input = { vehicleCategory, vehicleType };
        input.id = this.props.match.params.id;
        API.graphql(
            graphqlOperation(updateVehicleType, { input })
        ).then(res => {
            this.setState({ open: false })
            this.props.history.goBack()
        }).catch(err => {
        })
    }
    onCancel = () => {
        this.setState({ open: false, })
    }
    openEditModel = (e) => {
        e.preventDefault()
        this.setState({ open: true })
    }
    mainDiv = (success) => {
        let { vehicleCategory, vehicleType, open,vehicleCategories } = this.state;

        if (success === false) return null;
        return <Container className="pt-lg-sm pt-2">
            <EditConfirm onCancel={this.onCancel} onConfrim={this.submitHandler} open={open} />
            <Row className="justify-content-left">
                <Col lg={7}>
                    <Card className="bg-white pb-2 pt-3">
                        <CardHeader className="bg-white pb-2 pt-3" >
                            <div className=" pb-2"  >
                                <span style={{ fontSize: "30px" }}>Update Vehicle Type</span>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Form>
                                <Row>
                                    <Col lg={6}>
                                        <FormGroup>
                                            <InputGroup className="input-group-alternative mb-3">
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>

                                                    </InputGroupText>
                                                </InputGroupAddon>
                                                <Input id='vehicleType' placeholder={vehicleType} onChange={this.changeHandler} type="text"
                                                    value={vehicleType} />
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={6}>
                                        <FormGroup>
                                            <InputGroup className="input-group-alternative mb-3">
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>

                                                    </InputGroupText>
                                                </InputGroupAddon>
                                                <Input id="vehicleCategory" value={vehicleCategory} onChange={this.changeHandler} placeholder="Type Name" type="select" >
                                                    <option></option>
                                                    {vehicleCategories.map(item => {
                                                        return <option style={{ color: 'black' }}>{item}</option>
                                                    })}
                                                </Input>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <div className="text-center">
                                    <Row lg="12" className="px-3 ">
                                        <Col>
                                            <Button
                                                className=" btn-lg mt-2"
                                                color="primary"
                                                type="submit"
                                                onClick={this.openEditModel}
                                            >
                                                Submit
                                            </Button>
                                        </Col>


                                    </Row>
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    }
    render() {
        let { success } = this.state;

        return (
            <Fragment>
                {this.mainDiv(success)}
            </Fragment>
        );
    }
}
const mapStateToProps = state => {
    return {
        user: state.config.user,
        client: state.config.client
    };
};
export default connect(mapStateToProps, null)(UpdateVehicle)


// WEBPACK FOOTER //
// ./src/admin/vehicle/updateVehicalTypes.jsx